import * as z from "zod/v4";

export const getRiseAiIntegration = {
  name: "getRiseAiIntegration" as const,
  input: z.object({}),
  output: z.object({
    riseAiIntegration: z.optional(
      z.object({
        enabled: z.boolean(),
        riseAccountId: z.string().optional(),
        triggerKey: z.string().optional(),
        instanceId: z.string().optional(),
        useGiftCardApi: z.boolean().optional(),
        sourceChannelId: z.string().optional(),
      }),
    ),
  }),
};

export type GetRiseAiIntegrationOutput = z.infer<
  typeof getRiseAiIntegration.output
>;

export const setRiseAiIntegration = {
  name: "setRiseAiIntegration" as const,
  input: z.object({
    enabled: z.boolean(),
    riseAccountId: z.string().optional(),
    authToken: z.string().optional(),
    triggerKey: z.string().optional(),
    useGiftCardApi: z.boolean().optional(),
    sourceChannelId: z.string().optional(),
  }),
  output: z.object({}),
};

export const updateRiseAiIntegration = {
  name: "updateRiseAiIntegration" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    riseAccountId: z.string().optional(),
    authToken: z.string().optional(),
    triggerKey: z.string().optional(),
    useGiftCardApi: z.boolean().optional(),
    sourceChannelId: z.string().optional(),
  }),
  output: z.object({}),
};

export const disconnectRiseAiIntegration = {
  name: "disconnectRiseAiIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};

export const initiateRiseAiOAuth = {
  name: "initiateRiseAiOAuth" as const,
  input: z.object({}),
  output: z.object({ authUrl: z.string() }),
};
